// Stable API error codes returned by the backend in ApiError.code (mirrors the backend
// ComptabiliteAI.API.Util.ApiErrorCodes). The frontend keys off these — never inline the raw strings.
export const ApiErrorCode = {
    /** The server-side AcceoConnect session has expired; portal clients request a fresh launch nonce. */
    ConnectSessionExpired: 'connectSessionExpired',
    /** The Acomba user does not have sufficient rights to read the required data. */
    InsufficientAcombaRights: 'insufficientAcombaRights',
    /** The tenant/company could not be resolved — e.g. a desktop assertion whose société is unrecognized. */
    TenantInvalidIdentity: 'tenantInvalidIdentity',
    /** The connected Acomba copy holds fewer AR records than the one last synced AND its posted history is
     *  behind (or no high-water mark ruled that out) — a restored backup or an older company. Blocked rather
     *  than rebuilt, because rebuilding would adopt the older data as truth. Cleared only by an explicit
     *  promote. Mirrors backend BridgeSyncErrors.StaleCopy. */
    BridgeStaleCopy: 'staleCopy',
    /** The customer reply email is not a single bare address the reminder Reply-To and mailto link accept. */
    ReplyToEmailInvalid: 'replyToEmailInvalid',
    /** A custom reminder email with no language, or a language whose subject or body is blank or too long. */
    CustomEmailTemplateInvalid: 'customEmailTemplateInvalid',
} as const;

export type ApiErrorCode = (typeof ApiErrorCode)[keyof typeof ApiErrorCode];
